@if (options && options.length > 0) {
    @for (option of options; track option.value) {
        <div class="select__option" [ngClass]="option.is_selected ? 'select__option--selected' : ''" (click)="selectOption($event, option)">{{option.display_value}}</div>
    }
} @else {
    <div class="no__options__container">
        <span class="no__options__container__text">{{noOptionsText}}</span>
    </div>
}